module.exports = __webpack_public_path__ + "media/images/homepage/experience-bg-9a6acbfc17eb6a2bf5c150e653c2ea27.jpg";